import { Controller } from "stimulus"

export default class extends Controller {

    connect() {
        this._timeout = null
    }

    update() {
        clearTimeout(this._timeout)
        this._timeout = setTimeout(() => this._sendOverrides(), 500)
    }

    _sendOverrides() {
        const inputs = this.element.querySelectorAll('input[name^="line_overrides"]')
        const overrides = {}

        inputs.forEach(input => {
            const match = input.name.match(/line_overrides\[(\d+)\]\[(\w+)\]/)
            if (match) {
                const index = match[1]
                const field = match[2]
                if (!overrides[index]) overrides[index] = {}
                overrides[index][field] = input.value
            }
        })

        const urlParams = new URLSearchParams(window.location.search)
        fetch(`/customers/line_overrides?${urlParams.toString()}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute("content")
            },
            body: JSON.stringify({ line_overrides: overrides })
        })
            .then(response => response.text())
            .then(htmlString => {
                document.getElementById('order_details').innerHTML = htmlString
            })
    }
}
